import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Destination from '../../../images/company-dashboard/destination.svg'
import { toggleModal } from '../../reducers/modalReducer'
import PricingPageJourney from '../modals/pricingPageJourney'

const JourneyGuide = () => {
    const dispatch = useDispatch()
    const user = useSelector((state) => state.user)
    const [userType, setUserType] = useState('company')
    const [modalData, setModalData] = useState('investment')

    const handleJourney = (modelType) => {
        setModalData(modelType)
        if (user) {
            setUserType(user['role'].toLowerCase())
        }
        dispatch(toggleModal({ open: 'pricingPage' }))
    }

    return (
        <>
            <div
                className="usn pr bsbb w100 td250 my1rem ass"
            >
                <div className='py1rem bg19 br20px'>
                    <div className='pr'>
                        <Destination width="24" className="center-vertically f3 pa destinationIcon" style={{ left: '4px', width: '30px' }} />
                        <p className='pl2rem c15 ml1rem fs14px'>Your Journey</p>
                    </div>
                    <ul className='mt0-5rem px0-5rem'>
                        <li
                            className='journeyLi cp'
                            style={{ padding: '4px 8px' }}
                            onClick={() => handleJourney('investment')}
                        >
                            To Investment
                        </li>
                        <li
                            className='journeyLi cp'
                            style={{ padding: '4px 8px' }}
                            onClick={() => handleJourney('growth')}
                        >
                            To Growth
                        </li>
                        <li
                            className='journeyLi cp'
                            style={{ padding: '4px 8px' }}
                            onClick={() => handleJourney('exit')}
                        >
                            To Exit
                        </li>
                    </ul>
                </div>
            </div>

            <PricingPageJourney modaldata={modalData} userType={userType} />
        </>
    )
}

export default JourneyGuide